import { EMPTY_CONVERSATION_ID } from '@atlassian/conversation-assistant-store/controllers/chat';
import type { Conversation } from '@atlassian/conversation-assistant-store/controllers/chat/types';

/**
 * Decides whether `hydrateConversationWithExternalParams` should skip
 * the localStorage-based re-hydration on a container remount.
 *
 * Space-scoped conversations intentionally persist `EMPTY_CONVERSATION_ID`
 * to localStorage (see `setSelectedConversation.ts`) so a page refresh
 * starts fresh — the client UUID would otherwise become a ghost entry
 * in the `/conversations` list. That is correct on refresh but wrong on
 * mode-switch remount: `ChatStoreContainer.onInit` re-runs on every
 * mount, and the in-memory `chatStore` singleton still has the user's
 * active conversation. Skipping the localStorage read when we already
 * have an in-memory space conversation prevents the mode switch from
 * silently kicking the user back to the empty landing state.
 *
 * Returns `true` when the guard should fire (skip re-hydration).
 */
export const shouldPreserveSpaceChatOnHydrate = (
	currentConversationId: string | undefined,
	inMemoryConversation: Conversation | undefined,
): boolean => {
	if (!currentConversationId || currentConversationId === EMPTY_CONVERSATION_ID) {
		return false;
	}
	return Boolean(inMemoryConversation?.rovoSpaceId);
};
